<template>
  <div class="mobile-webdev-box">
    <div class="mobile-en-title">{{ "Website".toUpperCase() }}</div>
    <div class="mobile-cn-title">高端网站定制开发</div>
    <div v-html="cleanHtmlText(data.content)"></div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
